// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_15-2";
export var blackBorderOnHover = "_15-7";
export var cell = "_15-6";
export var cellContainer = "_15-3";
export var checked = "_15-8";
export var disabled = "_15-5";
export var featuredIconCellContainer = "_15-9";
export var featuredIconTextContainer = "_15-b";
export var featuredIconWrapper = "_15-a";
export var noBorder = "_15-c";
export var orangeSelectedRow = "_3p-3";
export var overflowableText = "_15-0";
export var overflowableTextContainer = "_15-1";
export var row = "_16-0";
export var rowCheckboxCell = "_15-4";
export var selectableTable = "_3p-2";